import type { ReactNode } from 'react';
import { AuthGate } from '@/auth/AuthGate';
import { useAuth } from '@/auth/AuthContext';
import { CP_LOGIN } from '@/lib/routes';

export interface RequireAuthProps {
  children: ReactNode;
}

/** Guards /cp/* — only a super-admin session opens these routes. */
export function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated } = useAuth();
  return (
    <AuthGate isAuthenticated={isAuthenticated} loginPath={CP_LOGIN}>
      {children}
    </AuthGate>
  );
}
